/**
 * 根据传入文件list页面全局创建下载链接
 * @param files
 */
export default (files=[]) => {
    const body = document.getElementsByTagName('body')[0];
    // 全部dom
    let printDom = document.createElement('div');
    printDom.className = 'printUrl';

    // 头部
    let topDom = document.createElement('div');
    topDom.className = 'printUrl-top';

    // 关闭按钮
    let topNameDom = document.createElement('div');
    topNameDom.innerText = '文件已生成完成，点击下方链接下载';
    topNameDom.className = 'printUrl-top-name';
    topNameDom.className = 'printUrl-top-name';

    // 关闭按钮
    let topCloseDom = document.createElement('i');
    topCloseDom.className = 'printUrl-top-close ivu-icon ivu-icon-close-round';
    topCloseDom.onclick = function(){
        body.removeChild(printDom);
    };

    // 主要部分
    let mainDom = document.createElement('div');
    mainDom.className = 'printUrl-main';

    files.map(file => {
        let a = document.createElement('a');
        a.setAttribute('href',file.href);
        a.setAttribute('target',"_blank");
        a.setAttribute('download','');
        a.innerHTML =`<i class="ivu-icon ivu-icon-md-arrow-down" style="font-size: 32px;"></i>` + file.name;
        mainDom.appendChild(a);
    });


    topDom.appendChild(document.createElement('div'));
    topDom.appendChild(topNameDom);
    topDom.appendChild(topCloseDom);
    printDom.appendChild(topDom);
    printDom.appendChild(mainDom);

    // 生成
    body.appendChild(printDom);
};



// WEBPACK FOOTER //
// ./src/static/js/utils/modules/createPdfUrl.js